/**
 * StickySidebar Class
 */
export class StickySidebar {

	/**
	 * Constructor
	 *
	 * @param {string} containerEl
	 * @return {void}
	 */
	constructor( containerEl ) {

		this.allBlocks = document.querySelectorAll( containerEl );
		if ( !this.allBlocks || this.allBlocks.length === 0 ) {

			return false;

		}
		/** Settings to change */
		this.headerHeightMargin = 16;

		/** Do not change */
		this.header = document.querySelector( "header" );
		this.headerHeight = 0;
		this.secondaryNavHeight = 0;

		this.secondaryNav = document.querySelector( ".b-secondary-navigation" );

		this.breakpoint = 858;
		this.mediaQuery = window.matchMedia( `(min-width:${ this.breakpoint }px)` );
		// this.init();
		this.mediaQuery.addEventListener( 'change', this.handleMediaQueryChange );
		this.handleMediaQueryChange( this.mediaQuery );

	}

	/**
	 * Has header
	 *
	 * @return {bool}
	 */
	hasHeader() {

		return this.header ? true : false;

	}

	/**
	 * Has secondary Navigation
	 *
	 * @return {bool}
	 */
	hasSecondaryNav() {

		return this.secondaryNav ? true : false;

	}

	/**
	 * Get Header Height
	 *
	 * @return {void}
	 */
	getHeaderHeight() {

		if ( this.hasHeader() ) {

			this.headerHeight =
				this.headerHeightMargin + this.header.offsetHeight;

		}

		if ( this.hasSecondaryNav() &&  !this.header.contains( this.secondaryNav ) ) {

			this.secondaryNavHeight = this.secondaryNav.offsetHeight;

		}

	}

	/**
	 * handleMediaQueryChange
	 *
	 * @param {object} e
	 */
	handleMediaQueryChange = ( e ) => {

		if ( e.matches ) {

			this.init();

		}else{

			this.allBlocks.forEach( ( block ) => {

				block.style.top = "";

			} );

		}

	}

	/**
	 * Init
	 *
	 * @return {void}
	 */
	init() {

		if ( this.allBlocks.length > 0 ) {

			this.getHeaderHeight();

			this.allBlocks.forEach( ( block ) => {

				if ( block.classList.contains( "is-sticky" ) ) {

					block.style.top = `${this.headerHeight + this.secondaryNavHeight }px`;

				}

			} );

		}

	}

}
